import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../GlobalContext'
import RedAlert from '../../ui-elements/RedAlert'
import { useParams } from 'react-router-dom'
import Button from '../../formfields/Button'
import Card from '../../ui-elements/Card'


type Props = {
    questionsFormFields: ObjectStringKeyAnyValue
    thisChecklist: ObjectStringKeyAnyValue | null
    questionsFormErrors: ObjectStringKeyAnyValue
    setQuestionsFormFields: React.Dispatch<React.SetStateAction<any>>
}



function SelectDateOptions({
    questionsFormFields,
    thisChecklist,
    questionsFormErrors,
    setQuestionsFormFields
}: Props) {

    const {
        tableData,
        currentOrganisation,
        sendMessageToWebsocket,
    } = useContext(GlobalContext)

    const { checklistId, questionId } = useParams()



    const handleChange = (value: string) => {
        const newFieldValues: ObjectStringKeyAnyValue = { ...questionsFormFields }
        newFieldValues.DateOptions = value
        setQuestionsFormFields(newFieldValues)
    }





    return <div className={`flex flex-col gap-2`}>
        <h3 className={`font-righteous text-brandblue text-lg`}>Dates to include:</h3>
        <div className={`flex flex-row felx-wrap gap-2`}>
            <Button
                onClick={() => handleChange('Past')}
                text={`Past dates`}
                variant={questionsFormFields.DateOptions === 'Past' ? 'primary' : 'gray'}
            />
            <Button
                onClick={() => handleChange('Future')}
                text={`Future dates`}
                variant={questionsFormFields.DateOptions === 'Future' ? 'primary' : 'gray'}
            />
            <Button
                onClick={() => handleChange('PastAndFuture')}
                text={`Past and future dates`}
                variant={questionsFormFields.DateOptions === 'PastAndFuture' ? 'primary' : 'gray'}
            />
        </div>
        {questionsFormErrors['DateOptions'] && <RedAlert alignment='left'>{questionsFormErrors['DateOptions']}</RedAlert>}
    </div>
}



export default SelectDateOptions